import { Vector3, Color4 } from '@babylonjs/core';
import { expr } from 'jquery';

export const constants = {
	cornerWidth: 4,
	cornerDepth: 8,
	deluxeDepth: 4,
	deluxeFullDepth: 16,
	middleWidth: 8,
	middleDepth: 4,
	balusterToSide: 0.192, //Distance from baluster to side wall
	cabinPorchDepth: 4,
	shuttersBox: '_shutters_box_obj',
	frameName: 'frame_',
	frameTopName: '_top',
	cutBlock: '_cut_block_obj',
	frameComponent: '__frame__',
	exteriorOffset: 0.3,
	interiorOffset: 0.1,
	doubleGablePorchDepth: 4,
	singleGablePorchDepth: 4,
	balusterCloneKey: 'balusterClones',
	postCloneKey: 'postClones',
	initRoofGableDegrees: 'initRoofGableDegrees',
	initLowerRoofDegrees: 'initLowerRoofDegrees',
	initUpperRoofDegrees: 'initUpperRoofDegrees',
	initSecondFloorHeight: 'initSecondFloorHeight',
	innerWallThickness: 0.04,
	moveAlongFloor: 'move_along_floor',
	tackDoorInfo: 'tackDoorInfo',
};

export const atticModel = {
	leanToWidth: 7.833, // 94"
	aFrameLeanToRoof: 0.208, // 2.5/12
	leanToHeight: 0, // 2.5/12
	secondFloorHeight: 7, // 84"
	porchWidth: 7.5, // 7'5"
	aFramePorchRoof: 0.208, // 2.5/12
	porchOffsetHeight: 0.583,
	barnOffsetHeight: 0.144,
	porchHeight: 0,
	barnLeanToRoof: 0.292, // 3.5/12
	barnPorchRoof: 0.208, // 2.5/12
	barnLeanToSpace: 3,
	overhang: 4.5,
	exteriorOffset: 0.4,
};

export const leanToFrontPorchOffsetTop = 0.5;

export const offsetTop = 1;
export const offsetBottom = {
	level1: 0.4,
	level2: 0.44,
	level3: 0.45,
};

export const aframeCabin = {
	porchOffsetHeight: 0.51,
};

export const componentTypeSettings = {
	door: {
		anchor: {
			horizontal: 'middle',
			vertical: 'ground',
		},
		moveable: {
			horizontal: true,
			vertical: false,
		},
	},
	garage_door: {
		anchor: {
			horizontal: 'middle',
			vertical: 'ground',
		},
		moveable: {
			horizontal: true,
			vertical: false,
		},
	},
	ramp: {
		anchor: {
			horizontal: 'middle',
			vertical: 'ground',
		},
		moveable: {
			horizontal: true,
			vertical: false,
		},
	},
	windows: {
		anchor: {
			horizontal: 'middle',
			vertical: 'wall',
		},
		moveable: {
			horizontal: true,
			vertical: true,
		},
	},
	skylight_window: {
		anchor: {
			horizontal: 'middle',
			vertical: 'roof',
		},
		moveable: {
			horizontal: true,
			vertical: true,
		},
	},
	vent: {
		anchor: {
			horizontal: 'middle',
			vertical: 'building',
		},
		moveable: {
			horizontal: true,
			vertical: true,
		},
	},
	cupola: {
		anchor: {
			horizontal: 'middle',
			vertical: 'building_top',
		},
		moveable: {
			horizontal: true,
			vertical: false,
		},
	},
	transom: {
		anchor: {
			horizontal: 'middle',
			vertical: 'building_top',
		},
		moveable: {
			horizontal: false,
			vertical: false,
		},
	},
	dormer: {
		anchor: {
			horizontal: 'middle',
			vertical: 'building_top',
		},
		moveable: {
			horizontal: true,
			vertical: false,
		},
	},
	shelf: {
		anchor: {
			horizontal: 'middle',
			vertical: 'ground',
		},
		moveable: {
			horizontal: true,
			vertical: false,
		},
	},
	workbench: {
		anchor: {
			horizontal: 'middle',
			vertical: 'ground',
		},
		moveable: {
			horizontal: true,
			vertical: false,
		},
	},
	switch: {
		anchor: {
			horizontal: 'middle',
			vertical: 'wall',
		},
		moveable: {
			horizontal: true,
			vertical: false,
		},
	},
	outlet: {
		anchor: {
			horizontal: 'middle',
			vertical: 'wall',
		},
		moveable: {
			horizontal: true,
			vertical: false,
		},
	},
	light: {
		anchor: {
			horizontal: 'middle',
			vertical: 'building_top',
		},
		moveable: {
			horizontal: true,
			vertical: false,
		},
	},
	breakerbox: {
		anchor: {
			horizontal: 'middle',
			vertical: 'wall',
		},
		moveable: {
			horizontal: true,
			vertical: false,
		},
	},
	flower_box: {
		anchor: {
			horizontal: 'middle',
			vertical: 'ground',
		},
		moveable: {
			horizontal: true,
			vertical: false,
		},
	},
	shutters: {
		anchor: {
			horizontal: 'middle',
			vertical: 'ground',
		},
		moveable: {
			horizontal: true,
			vertical: false,
		},
	},
};

export const distanceLineVerticalTopOptions = {
	points: [new Vector3(0, 0, 0), new Vector3(0, 0, 0)],
	updatable: true,
	instance: null,
	colors: [new Color4(0, 0, 0, 1), new Color4(0, 0, 0, 1)],
};

export const distanceLineVerticalBottomOptions = {
	points: [new Vector3(0, 0, 0), new Vector3(0, 0, 0)],
	updatable: true,
	instance: null,
	colors: [new Color4(0, 0, 0, 1), new Color4(0, 0, 0, 1)],
};

export const distanceLineHorizontalLeftOptions = {
	points: [new Vector3(0, 0, 0), new Vector3(0, 0, 0)],
	updatable: true,
	instance: null,
	colors: [new Color4(0, 0, 0, 1), new Color4(0, 0, 0, 1)],
};

export const distanceLineHorizontalRightOptions = {
	points: [new Vector3(0, 0, 0), new Vector3(0, 0, 0)],
	updatable: true,
	instance: null,
	colors: [new Color4(0, 0, 0, 1), new Color4(0, 0, 0, 1)],
};

export const NOTICES = {
	itemNotFit: `Items that don't fit the selected wall have been removed. Please consider changing the shed size or choosing a smaller item.`,
	cannotMove: 'Minimum spacing required for structural strength.',
	requireDoor: `Building requires at least one door.`,
	windowNotAdd: `Window cannot be added to building due to size compatibility. Consider a smaller window please.`,
	itemTooLarge: `Item is too large and has been removed. Rearrange the existing items for more space or try a smaller one.`,
	sideNotAccept: `Wall do not accept additional components.`,
	selectComponent: 'Please select the component.',
	cannotAddToCart: 'A shed can only be added to Cart if it has at least one door.',
	webGLNotSupport: `Model cannot be rendered due to WebGL service interruption. Reset or enable hardware acceleration in Chrome to fix this issue. <a href="https://shedpro.co/troubleshooting-chrome-service-error-for-3d-model-rendering/" target="_blank">See instructions.</a>`,
	doorRqdForWDWPos: `Building needs a door for proper window placement at fixed height.`,
	allowOneComponent: `This wall only allows one component to be added.`,
	cannotDetectSiding:
		'Cannot detect target siding for component customizations. Please rotate the model a little more, so your desired siding is prominently shown.',
	cannotAddComponent: 'Cannot add new component to this side.',
	missingInformation:
		'Unable to proceed with this order due to missing information. Please check to make sure you select custom option properly.',
	cannotNull: 'Custom line item name cannot be null.',
	shedDetailsUpdated: 'Shed details and price updated.',
	preventComponent: `This component can not add to here. Common reasons are due to restriction rules for siding materials or required spacing for equipment set.`,
	size: `Size restriction`,
	sidingMaterial: `Siding material restriction`,
	roofPitch: `Roof pitch restriction`,
	addOn: `Add on restriction`,
	sideSize: `Side & size restriction`,
	tackdoorCantMove: `Tackroom door cannot be moved.`,
	tackdoorMoveOutSide: `Tack door cannot be moved outside of tackroom wall.`,
	itemNotChange: `The item is fixed for this layout and cannot be changed.`,
	featureNotSupport: `Option not available for selected size.`,
	preventChangeComponent: `We cannot switch between components with different behavior.`,
	cannotPlaceVent: `Cannot place this vent because its required position on the model is occupied. Please move existing items to continue.`,
	loftNotCompatible: `Loft removed due to component incompatibility. Please adjust the component or choose another loft.`,
};

export const endGable2D = [
	'front',
	'back',
	'porch',
	'inner_front',
	'inner_back',
	'lean_to_back',
	'lean_to_front',
	'left_inner_porch',
	'right_inner_porch'
];
export const sideGable2D = [
	'right',
	'left',
	'inner_left',
	'left_back',
	'left_front',
	'front_inner_porch',
	'inner_right',
	'dormer',
	'top_left',
	'top_right',
	'lean_to_right',
];
export const reverseSides2D = [
	'back',
	'left',
	'inner_left',
	'left_back',
	'left_front',
	'front_inner_porch',
	'dormer',
	'top_left',
	'inner_back',
	'lean_to_back',
	'right_inner_porch'
];
export const ePackageType = ['switch', 'outlet', 'light', 'breakerbox'];
export const loftSides = ['front', 'back', 'left', 'right'];
export const zSide = [
	'left',
	'top_left',
	'right',
	'top_right',
	'inner_left',
	'left_front',
	'left_back',
	'front_inner_porch',
	'left_middle_porch',
	'inner_right',
	'lean_to_right',
	'roof_left',
	'roof_right',
];
export const positiveSide = [
	'front',
	'inner_front',
	'left',
	'inner_left',
	'left_front',
	'left_back',
	'front_inner_porch',
	'right_inner_porch',
	'lean_to_front',
	'top_front',
	'top_left',
	'porch',
	'roof_left',
	'floor',
];
export const typesCutFrame = ['door', 'windows', 'vent', 'transom'];
export const layoutTypes = [
	'door',
	'windows',
	'vent',
	'shelf',
	'workbench',
	'skylight_window',
	'misc_interior',
	'misc_exterior',
];
export const typeHasColor = ['door', 'windows', 'vent', 'shutters', 'misc_interior'];
export const interiors = [
	'shelf',
	'workbench',
	'switch',
	'outlet',
	'light',
	'breakerbox',
	'misc_interior',
	'stair',
];
export const colorLabels = {
	door: 'Door color',
	windows: 'Window color',
	vent: 'Vent color',
	shutters: 'Shutter color',
	countertops: 'Countertops color',
	appliance: 'Appliance color',
};

export const API_END_POINT = {
	SHED: '/api/shed/',
};

export const innerObjectName = {
	origin: 'new_inner_obj',
	cut: 'new_inner_cut_obj',
};

export const wallFinishName = {
	origin: 'wall_finish_obj',
	cut: 'wall_finish_cut_obj',
};

export const wallFinish = {
	mat1: 'wall_finish_mat_1',
	mat2: 'wall_finish_mat_2',
	mat3: 'wall_finish_mat_3',
	mat4: 'wall_finish_mat_4',
};

export const convertSides = { front: 'left', left: 'back', back: 'right', right: 'front' };
export const revertSides = { front: 'right', left: 'front', back: 'left', right: 'back' };

export const sideReverseShape = ['back', 'right'];

export const sizePlusX = [
	'left',
	'left_back',
	'left_front',
	'front_inner_porch',
	'inner_left',
	'top_left',
];
export const sizePlusZ = ['back', 'left_inner_porch', 'inner_back'];
export const roofSide = [
	'roof_left',
	'roof_right',
	'roof',
	'lower_roof_left',
	'lower_roof_right',
	'upper_roof_left',
	'upper_roof_right',
];
export const subComponentTypes = ['ramp', 'shutters', 'shutter', 'flower_box'];

export const colorCategories = [
	'siding',
	'trim',
	'roof',
	'shutter',
	'door',
	'vent',
	'windows',
	'wainscoting',
	'rails',
	'countertops',
	'wall',
	'appliance',
	'ceiling',
	'accent_gable',
];